import { buildFamsMenuMessages } from 'config/fams-menu';

export default {
  'menu.login': '登入',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作台',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.logout': '退出登入',
  ...buildFamsMenuMessages('zh-TW'),
};
